export default __webpack_public_path__ + "static/media/close-arrow.1af2cc71.svg";